// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'

// Internal Dependencies:
import { getUrlParameter } from 'utilities/url'

// Redux:
import { activateAccount } from 'actions/user'

class Activate extends React.Component {
	constructor( props ) {
		super( props )

		const redirectUrl = getUrlParameter( 'redirect_to' ) || siteData.site_url

		this.state = {
			redirectUrl: redirectUrl
		}
	}

	componentDidMount() {
		const { dispatch } = this.props
		const user_id = getUrlParameter( 'user' )
		const key = getUrlParameter( 'key' )

		dispatch( activateAccount( user_id, key ) )
	}

	render() {
		const { accountData, errorMessage } = this.props
		const { redirectUrl } = this.state
		const meta = {
			title: `Verifying your email - ${siteData.site_name}`
		}

		return (
			<div className="page-plain">
				<DocumentMeta { ...meta } />

				<div className="-inner">
					<div className="-content">
						{ accountData &&
							<div className="message">
								<h3>Email verified.</h3>

								<p>
									<a href={ redirectUrl } className="button">
										Continue
									</a>
								</p>
							</div>
						|| errorMessage &&
							<div className="message">
								<h3>Error.</h3>

								<p>
									There was an error activating your account.
								</p>
							</div>
						||
							<div className="message">
								<h3>Verifying your email...</h3>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.user.accountData,
		errorMessage: state.user.errorMessage
	}
}

export default connect( mapStateToProps )( Activate )
